export const googleTransList = {
  auto: "Automatic",
  af: "Afrikaans",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  hy: "Armenian",
  az: "Azerbaijani",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bs: "Bosnian",
  bg: "Bulgarian",
  ca: "Catalan",
  ceb: "Cebuano",
  ny: "Chichewa",
  "zh-CN": "Chinese (Simplified)",
  "zh-TW": "Chinese (Traditional)",
  co: "Corsican",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  nl: "Dutch",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  tl: "Filipino",
  fi: "Finnish",
  fr: "French",
  fy: "Frisian",
  gl: "Galician",
  ka: "Georgian",
  de: "German",
  el: "Greek",
  gu: "Gujarati",
  ht: "Haitian Creole",
  ha: "Hausa",
  haw: "Hawaiian",
  he: "Hebrew",
  iw: "Hebrew",
  hi: "Hindi",
  hmn: "Hmong",
  hu: "Hungarian",
  is: "Icelandic",
  ig: "Igbo",
  id: "Indonesian",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jw: "Javanese",
  kn: "Kannada",
  kk: "Kazakh",
  km: "Khmer",
  ko: "Korean",
  ku: "Kurdish (Kurmanji)",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lt: "Lithuanian",
  lb: "Luxembourgish",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  mi: "Maori",
  mr: "Marathi",
  mn: "Mongolian",
  my: "Myanmar (Burmese)",
  ne: "Nepali",
  no: "Norwegian",
  ps: "Pashto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  pa: "Punjabi",
  ro: "Romanian",
  ru: "Russian",
  sm: "Samoan",
  gd: "Scots Gaelic",
  sr: "Serbian",
  st: "Sesotho",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  es: "Spanish",
  su: "Sundanese",
  sw: "Swahili",
  sv: "Swedish",
  tg: "Tajik",
  ta: "Tamil",
  te: "Telugu",
  th: "Thai",
  tr: "Turkish",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  vi: "Vietnamese",
  cy: "Welsh",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  zu: "Zulu",
};
export const edgeTransList = {
  "": "Automatic",
  af: "Afrikaans",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  hy: "Armenian",
  as: "Assamese",
  az: "Azerbaijani (Latin)",
  bn: "Bangla",
  ba: "Bashkir",
  eu: "Basque",
  bs: "Bosnian (Latin)",
  bg: "Bulgarian",
  yue: "Cantonese (Traditional)",
  ca: "Catalan",
  lzh: "Chinese (Literary)",
  "zh-Hans": "Chinese Simplified",
  "zh-Hant": "Chinese Traditional",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  prs: "Dari",
  dv: "Divehi",
  nl: "Dutch",
  en: "English",
  et: "Estonian",
  fo: "Faroese",
  fj: "Fijian",
  fil: "Filipino",
  fi: "Finnish",
  fr: "French",
  "fr-ca": "French (Canada)",
  gl: "Galician",
  ka: "Georgian",
  de: "German",
  el: "Greek",
  gu: "Gujarati",
  ht: "Haitian Creole",
  he: "Hebrew",
  hi: "Hindi",
  mww: "Hmong Daw (Latin)",
  hu: "Hungarian",
  is: "Icelandic",
  id: "Indonesian",
  ikt: "Inuinnaqtun",
  iu: "Inuktitut",
  "iu-Latn": "Inuktitut (Latin)",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  kn: "Kannada",
  kk: "Kazakh",
  km: "Khmer",
  "tlh-Latn": "Klingon",
  "tlh-Piqd": "Klingon (plqaD)",
  ko: "Korean",
  ku: "Kurdish (Central)",
  kmr: "Kurdish (Northern)",
  ky: "Kyrgyz (Cyrillic)",
  lo: "Lao",
  lv: "Latvian",
  lt: "Lithuanian",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay (Latin)",
  ml: "Malayalam",
  mt: "Maltese",
  mi: "Maori",
  mr: "Marathi",
  "mn-Cyrl": "Mongolian (Cyrillic)",
  "mn-Mong": "Mongolian (Traditional)",
  my: "Myanmar",
  ne: "Nepali",
  nb: "Norwegian",
  or: "Odia",
  ps: "Pashto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese (Brazil)",
  "pt-pt": "Portuguese (Portugal)",
  pa: "Punjabi",
  otq: "Queretaro Otomi",
  ro: "Romanian",
  ru: "Russian",
  sm: "Samoan (Latin)",
  "sr-Cyrl": "Serbian (Cyrillic)",
  "sr-Latn": "Serbian (Latin)",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali (Arabic)",
  es: "Spanish",
  sw: "Swahili (Latin)",
  sv: "Swedish",
  ty: "Tahitian",
  ta: "Tamil",
  tt: "Tatar (Latin)",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tongan",
  tr: "Turkish",
  tk: "Turkmen (Latin)",
  uk: "Ukrainian",
  hsb: "Upper Sorbian",
  ur: "Urdu",
  ug: "Uyghur (Arabic)",
  uz: "Uzbek (Latin)",
  vi: "Vietnamese",
  cy: "Welsh",
  yua: "Yucatec Maya",
  zu: "Zulu",
};
